module.exports = __webpack_public_path__ + "static/media/item_11_4_comp.ad8fd455.png";